import React from 'react';
import * as Icons from 'lucide-react';

const EmailComingSoon = () => {
  return (
    <div className="min-h-[70vh] flex items-center justify-center">
      <div className="text-center max-w-lg">
        <div className="w-24 h-24 rounded-3xl flex items-center justify-center mx-auto mb-6" style={{
          background: 'linear-gradient(135deg, rgba(245, 158, 11, 0.1), rgba(217, 119, 6, 0.1))',
        }}>
          <Icons.Mail className="w-12 h-12" style={{ color: '#F59E0B' }} />
        </div>
        <h1 className="text-3xl font-bold text-gray-900 mb-3">Bulk Email Service</h1>
        <p className="text-gray-500 mb-6 leading-relaxed">
          Send professional bulk emails with advanced personalization, analytics, and deliverability optimization. Design beautiful templates and track every open and click.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
          {[
            { icon: 'Palette', label: 'Email Builder', desc: 'Drag & drop designer' },
            { icon: 'BarChart3', label: 'Analytics', desc: 'Opens, clicks, bounces' },
            { icon: 'Users', label: 'Segmentation', desc: 'Smart audience targeting' },
          ].map((feature) => {
            const Icon = Icons[feature.icon];
            return (
              <div key={feature.label} className="p-4 rounded-xl border border-gray-100 bg-white">
                {Icon && <Icon className="w-6 h-6 mx-auto mb-2" style={{ color: '#F59E0B' }} />}
                <p className="text-sm font-semibold text-gray-900">{feature.label}</p>
                <p className="text-xs text-gray-400 mt-0.5">{feature.desc}</p>
              </div>
            );
          })}
        </div>
        <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-medium" style={{
          background: 'linear-gradient(135deg, rgba(245, 158, 11, 0.08), rgba(217, 119, 6, 0.08))',
          color: '#D97706',
          border: '1px solid rgba(245, 158, 11, 0.15)',
        }}>
          <Icons.Clock className="w-4 h-4" />
          Coming Soon - Under Development
        </div>
      </div>
    </div>
  );
};

export default EmailComingSoon;
